import axios, { buildApi } from "@/libs/api.request";
let name = '/common/PackingAirport'

export const apis = buildApi({
  get: [name + '/index&list',],
  post: [name + '/save', name + '/delete/:id&del']
})